import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { ConfigService } from '../../../../../config/config.service'
import { CommandeSettingsArticles, CommandeSettingsArticlesMultiple, CommandeSettingsClient, CommandeSettingsCoeff, CommandeSettingsConditionnement, CommandeSettingsDeliveries } from './commande-param-settings'

@Injectable({
  providedIn: 'root'
})
export class CommandeParamSettingsService {


  constructor(
    private configService: ConfigService,
    private http: HttpClient
  ) { }

  public getCommandDeliveries(idClient: string): Observable<CommandeSettingsDeliveries[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<CommandeSettingsDeliveries[]>(config.apiPoint + config.getLHClientDelivery.replace("{client}", idClient))
      })
    )
  }

  public getCommandMaxOrderRatio(idClient: string): Observable<CommandeSettingsCoeff> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<CommandeSettingsCoeff>(config.apiPoint + config.getLHClientMaxOrderRatio.replace("{client}", idClient))
      })
    )
  }

  public putCommandMaxOrderRatio(idClient: string, commandeSettingsCoeff: CommandeSettingsCoeff) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.put<CommandeSettingsCoeff>(
          config.apiPoint + config.putLHClientMaxOrderRatio
            .replace("{client}", idClient),
          commandeSettingsCoeff
        )
      })
    )
  }

  public getCommandConditionnement(idClient: string): Observable<CommandeSettingsConditionnement> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<CommandeSettingsConditionnement>(config.apiPoint + config.getLHClientConditionnement.replace("{client}", idClient))
      })
    )
  }

  public putCommandConditionnement(idClient: string, commandeSettingsConditionnement: CommandeSettingsConditionnement) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.put<CommandeSettingsConditionnement>(
          config.apiPoint + config.putLHClientConditionnement
            .replace("{client}", idClient),
          commandeSettingsConditionnement
        )
      })
    )
  }

  public patchCommandeSettingsDeliveries(idClient: string, commandeSettingsDeliveries: CommandeSettingsDeliveries[]) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.patch<CommandeSettingsDeliveries[]>(
          config.apiPoint + config.patchLHClientDelivery
            .replace("{client}", idClient), commandeSettingsDeliveries
        )
      })
    )
  }

  public getCommandSettingsArticles(idClient: string): Observable<CommandeSettingsArticles[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<CommandeSettingsArticles[]>(
          config.apiPoint + config.getLHClientArticles.replace("{client}", idClient)
        )
      })
    )
  }

  public patchCommandSettingsArticles(idClient: string, commandeSettingsArticle: CommandeSettingsArticles, isTmpLingerie) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.patch<CommandeSettingsArticles>(
          config.apiPoint + config.patchLHClientArticle
            .replace("{article}", commandeSettingsArticle.id),
          commandeSettingsArticle,
          { params: { isTmpLingerie: isTmpLingerie } }
        )
      })
    )
  }

  public patchCommandSettingsArticlesMultiple(idClient: string, commandeSettingsArticleMultiple: CommandeSettingsArticlesMultiple) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.patch<CommandeSettingsArticlesMultiple>(
          config.apiPoint + config.patchLHClientArticleMultiple
            .replace("{client}", idClient),
          commandeSettingsArticleMultiple
        )
      })
    )
  }

  public patchCommandeSettingsClient(idClient: string, settings: CommandeSettingsClient) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.put<CommandeSettingsCoeff>(
          config.apiPoint + config.patchCommandeSettingsClient
            .replace("{client}", idClient),
          settings
        )
      })
    )
  }

  public patchCommandeSettingsStatistics(statistics) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.put(config.apiPoint + config.patchCommandeSettingsStatistics, statistics)
      })
    )
  }

}
